import { Injectable } from '@angular/core';
const googleLibPhoneNumber = require('google-libphonenumber');
@Injectable({
  providedIn: 'root'
})

export class PhoneNumberService {
  static PNF: any;
  static _Lib: any;
  static phoneUtils: any;
  static supportedRegions: any;
  static countryCodes: any;
  static parseEmergencyContacts: (phoneNumber: any) => any;
  static rebuildEmergencyContacts: (phoneNumber: any) => any;
  constructor() {
    PhoneNumberService.PNF = googleLibPhoneNumber.PNF;
    PhoneNumberService._Lib = googleLibPhoneNumber;
    PhoneNumberService.phoneUtils = googleLibPhoneNumber.PhoneNumberUtil.getInstance();

    PhoneNumberService.supportedRegions = PhoneNumberService.phoneUtils.getSupportedRegions();

    PhoneNumberService.countryCodes = PhoneNumberService.supportedRegions.map((country: any) => ({
      country,
      prefix: '+' + PhoneNumberService.phoneUtils.getCountryCodeForRegion(country)
    }));

    PhoneNumberService.parseEmergencyContacts = (emergencyContact) => {
      if (!emergencyContact.phone) {
        return emergencyContact;
      }
      const number = PhoneNumberService.phoneUtils.parse(emergencyContact.phone);
      return {
        ...emergencyContact,
        phone: number.getNationalNumber(),
        prefix: number.getCountryCode(),
        full: emergencyContact.phone
      };
    };

    PhoneNumberService.rebuildEmergencyContacts = (phoneNumber) => ({
      ...phoneNumber,
      phone: phoneNumber.prefix + phoneNumber.phone,
      prefix: undefined,
      full: undefined
    });

    return PhoneNumberService;
  }
}
